export default {
  styleOverrides: {
    button: {
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.04)'
      }
    }
  }
}
